<div
  class="avatar {{ variant() }} size-{{ size() }} {{ color() }}"
  [class.hover]="clickable()"
  [class.f-body-xs]="[16, 20, 24].includes(size())"
  [class.f-paragraph-m]="size() === 60"
  [class.f-medium]="size() === 60"
>
  @if (variant() === 'user') {
    {{ initials() || '?' }}

    @if (user()?.avatar) {
      <div
        class="backdrop {{ `size-${size()}` }}"
        [class.hover]="clickable()"
      ></div>
    }
  } @else if (variant() === 'company') {
    @if (company() && company()?.logo == null) {
      <onyx-icon
        name="contractor-outlined"
        [size]="companyIconSize()"
      ></onyx-icon>
    } @else {
      <span>?</span>
    }
  }

  @if (background$() | async; as background) {
    <div
      class="image {{ variant() }} {{ `size-${size()}` }}"
      [style.background]="background"
    ></div>
  }
</div>
